import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-metadata-flags-table',
    templateUrl: './metadata-flags-table.component.html',
    styleUrls: ['./metadata-flags-table.component.scss']
})
export class MetadataFlagsTableComponent implements OnInit {
    @Input() data: { metric: string, value: number }[];

    years: number[] = [];
    selectedYear: number;

    staticData = [
        { metric: 'Author', value: 155 },
        { metric: 'Creation date', value: 146 },
        { metric: 'Blank/Wiped properties', value: 135 },
        { metric: 'Revision Authors', value: 122 }
    ];

    get tableData() {
        return this.data && this.data.length ? this.data : this.staticData;
    }

    constructor() { }
    ngOnInit(): void {
        const currentYear = new Date().getFullYear();
        this.years = Array.from({ length: 5 }, (_, i) => currentYear - i).reverse();
        this.selectedYear = currentYear;
    }
} 